module.exports = __webpack_public_path__ + "static/img/indexbg4.f0225f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg4.png
// module id = dGrf
// module chunks = 1